import { render, staticRenderFns } from "./WorkflowSession.vue?vue&type=template&id=2b54ec00&scoped=true"
import script from "./WorkflowSession.vue?vue&type=script&lang=js"
export * from "./WorkflowSession.vue?vue&type=script&lang=js"
import style0 from "./WorkflowSession.vue?vue&type=style&index=0&id=2b54ec00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b54ec00",
  null
  
)

export default component.exports